import {Component, ElementRef, OnInit} from '@angular/core';
import {AccountType} from '@ee/common/enums';

@Component({
  selector: 'ee-comparison',
  template: `
    <div class="ee-pricing landing-container pricing auth-container flex flex-col">
      <ee-product-comparison [type]="selectedType" [paddingTop]="navHeightPx"></ee-product-comparison>
    </div>
  `,
  styles: [
    `
      .ee-pricing {
        font-family: 'Barlow', sans-serif;
        margin: 0;
        padding: 0;

        .landing-container {
          padding-bottom: 30px;
        }

        .mat-toolbar.header {
          z-index: 100;
        }

        .step-name {
          font-size: 1rem;
          font-weight: bold;
        }

        h1 {
          font-weight: 600;
        }

        h2 {
          font-weight: 700;
          font-size: 1.5rem;

          &.main-header {
            font-weight: 600;

            &.top {
              margin-top: 16px;
            }
          }
        }

        .dates {
          font-size: 1rem;

          b {
            line-height: 10px;
            font-weight: 500;
          }
        }
      }
    `
  ],
  standalone: false
})
export class ComparisonComponent implements OnInit {
  public selectedType: AccountType;
  public navHeightPx: number;

  constructor(private elementRef: ElementRef) {
  }

  ngOnInit() {
    this.selectedType = AccountType[this.elementRef.nativeElement.getAttribute('type')];
    this.navHeightPx = Number(this.elementRef.nativeElement.getAttribute('navHeightPx'));
  }
}
